import { render } from "./Cursor.vue?vue&type=template&id=56c7b6df&scoped=true&ts=true"
import script from "./Cursor.vue?vue&type=script&lang=ts"
export * from "./Cursor.vue?vue&type=script&lang=ts"

import "./Cursor.vue?vue&type=style&index=0&id=56c7b6df&lang=css&scoped=true"

import exportComponent from "/opt/buildhome/repo/node_modules/@vue/cli-service/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-56c7b6df"]])

export default __exports__